import {
  CMHeadingContainer,
  CMBox,
  CMBoxcontainer,
  CMFooter,
} from "./order-confirmed.styles";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import { useState } from "react";
import { Link } from "react-router-dom";

const OrderConfirmed = ({
  handleNext,
  handlePrev,
  orderText,
  orderInform,
  orderInform2,
  linkText,
  balance,
  totalBid,
  balanceFee,
  orderType,
  type,
  issuerPair
}) => {

  //  const cleanTotalBid = totalBid.replace('$', '').replace(/,/g, '') || "---";
  const cleanBalance = balance?.replace(/,/g, '') || "---";
  //const totalBidWithFee = ((balanceFee / 100) * parseFloat(cleanTotalBid));
  const totalActually = parseFloat(cleanBalance) || "---";
  //- parseFloat(cleanTotalBid) - totalBidWithFee
  const totalActuallyFormatted = totalActually.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <>
      <CMBoxcontainer >
        <CMHeadingContainer>
          <h3>{orderText}</h3>
        </CMHeadingContainer>
        <CMBox>
          <h3>{orderInform}<br />{orderType === "Market" ? "" : orderInform2}</h3>
          <div style={{ textAlign: "center", marginTop: "5px" }}>
            {/* <h3 id="balanceAC">Available cash: {totalActuallyFormatted}</h3> */}
          </div>
        </CMBox>
      </CMBoxcontainer>
      <CMFooter>

        {orderType === "Limit" ? <p>You can cancel this order, only before it is successfully matched, from the <Link to={"/portfolio"} state={{ activeTab: 1 }}>
          "Pending orders"
        </Link>{" "}
          section </p> : orderType === "Market" ? "" : <p>
            You can view your submitted bid(s) in the{" "}
            <Link to={"/portfolio"} state={{ activeTab: 1 }}>
              "Pending orders"
            </Link>{" "}
            section
          </p>}
        {orderType === "Limit" && issuerPair && type === "Sell" && <p>Trading of units by its Issuer is subject to certain limitations as further elaborated on MusicBull <Link to={"/terms-conditions"}>
          Terms of Services
        </Link>{" "}.</p>}
      </CMFooter>
     
    </>
  );
};
export default OrderConfirmed;
